import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getSharedStrategies } from '../../../services/StrategiesService';
import SharedStrategyRow from './SharedStrategyRow';
import SwitchInput from '../../../components/SwitchInput/SwitchInput';
import { PageTableCard } from '../../../components/PrivatePage';
import Pager from '../../../components/Pager/Pager';
import ViewStrategyModal from './ViewStrategyModal';

/**
 * props:
 * - symbol
 * - onNotification
 */
function SharedStrategies(props) {

    const history = useHistory();

    const [strategies, setStrategies] = useState([]);

    const [count, setCount] = useState(0);

    const [viewStrategy, setViewStrategy] = useState({});

    const [page, setPage] = useState(1);

    const [includePublic, setIncludePublic] = useState(true);

    useEffect(() => {
        getSharedStrategies(props.symbol, includePublic, page || 1)
            .then(result => {
                setStrategies(result.rows);
                setCount(result.count);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                props.onNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }, [page, props.symbol, includePublic])

    function onViewClick(event) {
        const id = event.target.id.replace('view', '');
        setViewStrategy(strategies.find(s => s.id == id));
    }

    function onPublicChange(event) {
        setIncludePublic(event.target.value);
    }

    return (
        <React.Fragment>
            <div className="private-page-section-header">
                <h2 className="private-page-section-title">Shared bots</h2>
                <SwitchInput id="includePublic" text="Include public?" isChecked={includePublic} onChange={onPublicChange} />
            </div>
            <PageTableCard>
                <div className="table-wrapper table-responsive">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th className="border-gray-200">Symbol</th>
                            <th className="border-gray-200">Name</th>
                            <th className="border-gray-200">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            strategies && strategies.length
                                ? strategies.map(strategy => (<SharedStrategyRow key={strategy.id} data={strategy} onViewClick={onViewClick} />))
                                : <React.Fragment></React.Fragment>
                        }
                    </tbody>
                </table>
                </div>
                <Pager count={count} page={page} size={10} onClick={setPage} />
            </PageTableCard>
            <ViewStrategyModal data={viewStrategy} />
        </React.Fragment>
    )
}

export default SharedStrategies;